import React from 'react';
export function BenefitsSection() {
  const benefits = [{
    icon: '🧭',
    title: 'A clear day-by-day path',
    desc: '21 days of sequenced practices. No improvising, no wondering what to do today. Just follow the system.'
  }, {
    icon: '🛡️',
    title: 'Tools for the moment of the urge',
    desc: 'You stop being defenseless when the cycle pulls hardest. You have a response ready.'
  }, {
    icon: '🔓',
    title: 'Guilt stops being the bridge back',
    desc: 'You work with guilt instead of suppressing it. That breaks the connection that turns it into a trigger.'
  }, {
    icon: '⏱️',
    title: '5 to 15 minute practices',
    desc: 'No disruption to your life. No excuses about time. If you have time for the cycle, you have time to interrupt it.'
  }, {
    icon: '🤝',
    title: 'Language without judgment or labels',
    desc: 'You accompany yourself instead of attacking yourself. The process is kind to whoever does it.'
  }, {
    icon: '🔒',
    title: '100% private',
    desc: 'Nobody needs to know you are working on this. It is between you and the process.'
  }];
  return <section className="py-6 md:py-9 px-5 bg-gradient-to-b from-card-bg to-dark-bg" data-id="element-14" data-mp="2l5ifgi82bd7w">
      <div className="max-w-[900px] mx-auto" data-id="element-15" data-mp="2g5w5qirg0f3u">
        <span className="inline-block font-heading font-bold text-[0.75rem] tracking-[3px] uppercase text-magenta-bright mb-2" data-id="element-16" data-mp="2g77586duv0p5">
          What you get
        </span>
        <h2 className="text-[clamp(1.6rem,4vw,2.5rem)] font-heading font-black leading-[1.15] mb-3" data-id="element-17" data-mp="1of82n167kznj">
          Not more information.
          <br data-id="element-18" data-mp="22fakineint2s" />
          <span className="text-gradient-magenta" data-id="element-19" data-mp="22fsok67f7bl9">Real tools.</span>
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-[repeat(auto-fit,minmax(260px,1fr))] gap-3 mt-4" data-id="element-20" data-mp="1xemuo520xia5">
          {benefits.map((benefit, idx) => <div key={idx} className="bg-gradient-to-br from-[rgba(107,0,182,0.12)] to-[rgba(194,0,111,0.08)] border border-[rgba(107,0,182,0.3)] rounded-2xl p-4 transition-[transform,border-color,box-shadow] duration-300 hover:-translate-y-[5px] hover:border-magenta hover:shadow-[0_10px_40px_rgba(194,0,111,0.2)]" data-id="element-21" data-mp="38ujq8c4db0gc" data-mpi={idx}>
              <div className="text-[2rem] mb-2" data-id="element-22" data-mp="3pwh0igh1tmv8">{benefit.icon}</div>
              <h4 className="text-[1.05rem] font-heading font-extrabold text-white mb-1" data-id="element-23" data-mp="3uvadm7sfbbuv">
                {benefit.title}
              </h4>
              <p className="text-[0.9rem] leading-[1.5] text-white/70" data-id="element-24" data-mp="2x9354mt00zd8">
                {benefit.desc}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}